import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Formit from 'react-formit';
import {
  SecondaryTitle,
  Card,
  CardSpacing,
  CardContent,
  Edit
} from './CommonUiComponents';
import { WORDPRESS_URL } from '../utils/constants';
import { cross, editWhite } from '../utils/icons';
import { textGray, red } from '../utils/colors';

const Block = styled.div`
  margin: 1.31rem 0;
`;

const Label = styled.label`
  font-size: 1rem;
  font-weight: 600;
  display: block;
  margin: 0 0 0.15rem;
  color: ${textGray};

  ${props =>
    props.inverted &&
    css`
      color: #ffffff;
    `};
`;

const Text = styled.p`
  margin: 0;
  font-weight: 300;

  ${props =>
    props.inverted &&
    css`
      color: #ffffff;
    `};
`;

const Input = styled.input`
  font-size: 1rem;
  font-weight: 300;
  border: none;
  border-radius: 0.25rem;
  border: 0;
  height: 30px;
  width: 100%;
  padding-left: 0.5rem;
`;

const Button = styled.button`
  background: ${props => props.theme.tertiary};
  display: inline-block;
  border: 0;
  padding: 0.5rem 1.2rem;
  font-size: 0.8125rem;
  color: #ffffff;
  cursor: pointer;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 1px;
  outline: none;
  border-radius: 4px;
  width: 100%;
  margin-top: 1.5rem;
`;

const Error = styled.div`
  font-weight: 600;
  margin-top: 1rem;
  text-transform: uppercase;
  color: ${red};
`;

const Success = Error.extend`
  color: ${props => props.theme.tertiary};
`;

function printResponse(code) {
  switch (code) {
    case 'password_changed':
      return <Success>Passord endret!</Success>;
    case 'data_missing':
      return <Error>Skriv inn både gammelt og nytt passord.</Error>;
    case 'old_password_mismatch':
      return <Error>Gammelt passord er feil.</Error>;
    default:
      return null;
  }
}

class ProfileSettings extends Component {
  state = {
    editMode: false,
    passwordsDontMatch: false
  };

  render() {
    const { userData, invertedTheme } = this.props;
    const { editMode, passwordsDontMatch } = this.state;

    return (
      <Card>
        <CardSpacing>
          <CardContent>
            <SecondaryTitle inverted={invertedTheme}>
              Mine opplysninger{' '}
              <Edit
                href="#"
                inverted={invertedTheme}
                onClick={e => {
                  e.preventDefault();
                  this.setState({ editMode: !editMode });
                }}
              >
                {editMode ? cross : editWhite}
              </Edit>
            </SecondaryTitle>
            <Block>
              <Label inverted={invertedTheme}>Brukernavn</Label>
              <Text inverted={invertedTheme}>{userData.user_display_name}</Text>
            </Block>
            {editMode ? (
              <Block>
                <Formit
                  action={`${WORDPRESS_URL}/userdata/v1/newpassword`}
                  headers={[
                    {
                      Authorization: `Bearer ${userData.token}`
                    }
                  ]}
                  responseAsJSON
                >
                  {({
                    onSubmit,
                    setValue,
                    getValue,
                    clearValues,
                    isPosting,
                    postingError,
                    responseData
                  }) => (
                    <form
                      onSubmit={e => {
                        e.preventDefault();

                        if (getValue('new') !== getValue('repeat')) {
                          this.setState({ passwordsDontMatch: true });
                          return false;
                        }

                        this.setState({ passwordsDontMatch: false });
                        return onSubmit(e);
                      }}
                    >
                      <Block>
                        <Label for="oldPasword" inverted={invertedTheme}>
                          Gammelt passord
                        </Label>
                        <Input
                          id="oldPasword"
                          type="password"
                          value={getValue('old')}
                          onChange={e => setValue('old', e.target.value)}
                        />
                      </Block>
                      <Block>
                        <Label for="newPasword" inverted={invertedTheme}>
                          Nytt passord
                        </Label>
                        <Input
                          id="newPasword"
                          type="password"
                          value={getValue('new')}
                          onChange={e => setValue('new', e.target.value)}
                        />
                      </Block>
                      <Block>
                        <Label for="repeatPasword" inverted={invertedTheme}>
                          Gjenta nytt passord
                        </Label>
                        <Input
                          id="repeatPasword"
                          type="password"
                          value={getValue('repeat')}
                          onChange={e => setValue('repeat', e.target.value)}
                        />
                        {responseData && printResponse(responseData.code)}
                        {passwordsDontMatch && (
                          <Error>Passordene er ulike.</Error>
                        )}
                        <Button type="submit" disabled={isPosting}>
                          {isPosting ? 'Endrer...' : 'Endre passord'}
                        </Button>
                      </Block>
                    </form>
                  )}
                </Formit>
              </Block>
            ) : (
              <Block>
                <Label inverted={invertedTheme}>Passord</Label>
                <Text inverted={invertedTheme}>******</Text>
              </Block>
            )}
            {userData.phone !== '' && (
              <Block>
                <Label inverted={invertedTheme}>Telefon</Label>
                <Text inverted={invertedTheme}>{userData.phone}</Text>
              </Block>
            )}
            <Block>
              <Label inverted={invertedTheme}>E-post</Label>
              <Text inverted={invertedTheme}>{userData.user_email}</Text>
            </Block>
            {userData.institution !== '' && (
              <Block>
                <Label inverted={invertedTheme}>Arbeidsplass</Label>
                <Text inverted={invertedTheme}>{userData.institution}</Text>
              </Block>
            )}
          </CardContent>
        </CardSpacing>
      </Card>
    );
  }
}

ProfileSettings.propTypes = {
  invertedTheme: PropTypes.bool.isRequired,
  userData: PropTypes.shape({
    user_display_name: PropTypes.string.isRequired,
    user_email: PropTypes.string.isRequired,
    phone: PropTypes.string,
    institution: PropTypes.string
  }).isRequired
};

export default ProfileSettings;



// WEBPACK FOOTER //
// ./src/components/ProfileSettings.js